<template>
    <div class="member-list">
        <van-tabs v-model="active" @change="switchTab" :ellipsis="false" class="list">
            <van-tab
                v-for="(item, index) in pageInfo.skuList"
                :key="index"
                :title="item.category"
                :data-entrance="item.category"
                v-intersection
                :data-log="JSON.stringify({ gio: skuShowGioDataLog(item) })"
            >
                <div v-if="showTop" class="space"></div>
                <div class="member-title" style="margin-top:0.12rem;">会员面额</div>
                <member-detail
                    :categoryDetailList="categoryDetailList"
                    :isCY="isCY"
                    :isSC_CY="isSC_CY"
                    :isSourceChannel="isSourceChannel"
                    :productIndex="productIndex"
                    :showTips="showTips"
                    :pageInfo="pageInfo"
                    @select="changeProductIndex"
                    @close-tips="$emit('close-tips')"
                />
                <template v-if="hasUnion">
                    <div class="member-title">联合会员</div>
                    <member-detail
                        :isUnion="true"
                        :categoryDetailList="categoryDetailList"
                        :isCY="isCY"
                        :isSC_CY="isSC_CY"
                        :isSourceChannel="isSourceChannel"
                        :productIndex="productIndex"
                        :showTips="showTips"
                        :pageInfo="pageInfo"
                        @select="changeProductIndex"
                        @close-tips="$emit('close-tips')"
                    />
                </template>
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
import Tab from 'vant/lib/tab';
import Tabs from 'vant/lib/tabs';
import MemberDetail from './MemberDetail.vue';
import 'vant/lib/tab/style';
import 'vant/lib/tabs/style';
import { onVisibilityChange } from 'root/common/nativeApi/index';
import env from '@/common/util/env';

export default {
    name: 'MemberList',
    components: {
        'van-tab': Tab,
        'van-tabs': Tabs,
        MemberDetail,
    },
    props: {
        pageInfo: {
            type: Object,
            default: () => {},
        },
        categoryDetailList: {
            type: Array,
            default: () => [],
        },
        isCY: {
            type: Boolean,
            default: false,
        },
        isSC_CY: {
            type: Boolean,
            default: false,
        },
        isSourceChannel: {
            type: Boolean,
            default: false,
        },
        productIndex: {
            type: Number,
            defaultValue: -1,
        },
        categoryIndex: {
            type: Number,
            defaultValue: -1,
        },
        showTips: {
            type: Boolean,
            defaultVaule: false,
        },
        hasUnion: {
            type: Boolean,
            defaultValue: false,
        },
    },
    data() {
        return {
            active: 0,
        };
    },
    created() {
        if (env.isApp) {
            onVisibilityChange(visibile => {
                if (visibile) {
                    this.active = 0;
                }
            });
        }
    },
    methods: {
        changeProductIndex(index, item) {
            this.$emit('select', index, item);
        },
        switchTab(index) {
            this.$emit('switch', index);
        },
        skuShowGioDataLog(sku) {
            return JSON.stringify({
                productName_var: this.pageInfo.product.name,
                productSkuName_var: '/',
                productSkuid_var: '/',
                productCategory_var: sku.category,
            });
        },
    },
    computed: {
        showTop() {
            const { productIndex, categoryDetailList, showTips } = this;
            if (
                categoryDetailList[productIndex] &&
                categoryDetailList[productIndex].payment_cycle !== 0 &&
                showTips &&
                productIndex < 3
            ) {
                return true;
            }
            return false;
        },
    },
    watch: {
        categoryIndex: {
            handler(newVal) {
                this.active = newVal;
            },
            immediate: true,
        },
    },
};
</script>
<style lang="scss" scoped>
.member-list {
    border-radius: 0.16rem;
    background: #fff;
    margin: 0.16rem 0.24rem 0 0.24rem;
    position: relative;
    padding-top: 0.24rem;

    .space {
        width: 100%;
        height: 0.76rem;
    }

    .list {
        ::v-deep .van-tab__pane {
            border-bottom: 1px solid transparent;
        }

        ::v-deep .van-hairline--top-bottom::after {
            border-width: 0;
        }

        ::v-deep .van-tabs__line {
            background-color: transparent;
        }

        ::v-deep .van-tabs__wrap {
            z-index: 0;
            padding-top: 0.24rem;
        }

        ::v-deep .van-tabs__wrap--scrollable {
            padding: 0;
            // padding: 0 0.18rem;
            height: 0.72rem;
            padding-bottom: 0.01rem;

            .van-tabs__nav--line {
                .van-tab--complete {
                    flex-grow: 0;
                    margin: 0 0.08rem;
                    font-size: 0.32rem;
                    color: #252220;
                    border-radius: 0.08rem;
                    padding: 0 0.32rem;
                    border: 0.01rem solid #e6e6e6;

                    span {
                        line-height: 0.72rem;
                    }

                    &:nth-child(2) {
                        margin-left: 0.24rem;
                    }

                    &:last-child {
                        margin-right: 0.24rem;
                    }

                    &.van-tab--active {
                        position: relative;
                        font-weight: 600;
                        color: #ff4b21 !important;
                        border: 0.04rem solid #ee9f5c;
                        background: rgba(255, 203, 158, 0.1);
                        height: 0.72rem;

                        &::before {
                            content: '';
                            display: block;
                            width: 0.44rem;
                            height: 0.44rem;
                            background: center / 100% 100% url(../../../images/icon-corner.png);
                            position: absolute;
                            right: -0.02rem;
                            bottom: -0.02rem;
                            border-radius: 0 0 0.08rem 0;
                        }

                        span {
                            line-height: 0.64rem;
                        }
                    }
                }
            }
        }
    }

    .member-title {
        margin-left: 0.24rem;
        font-size: 0.28rem;
        color: #666;
        line-height: 0.4rem;
    }
}
</style>
